import { Injectable, NgZone } from '@angular/core';

import { Message, MessageService } from 'primeng/api';

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    constructor(
        private messageService: MessageService,
        private zone: NgZone,) { }

    success(detail: string, summary: string) {
        this.messageService.add({ severity: 'success', summary: summary, detail: detail, key: 'toast' } as Message);
    }

    info(detail: string, summary: string) {
        this.messageService.add({ severity: 'info', summary: summary, detail: detail, key: 'toast' } as Message);
    }

    show(message: Message) {
        message.key = 'toast';
        this.messageService.add(message);
    }

    clear() {
        this.messageService.clear('toast');
    }

}
